/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable complexity */
import FormWatcher from '@/inheritance/form-watcher';
import OperationAddExecuteOperation from '@/views/operation-details/operations-add/operation-add-execute-operation';
import OperationAddProgress from '@/views/operation-details/operations-add/operation-add-progress';
import OperationAddSelectAccount from '@/views/operation-details/operations-add/operation-add-select-account';
import OperationAddSelectOperation from '@/views/operation-details/operations-add/operation-add-select-operation';

export default {
    name: 'OperationAdd',
    extends: FormWatcher,
    components: {
        OperationAddProgress,
        OperationAddExecuteOperation,
        OperationAddSelectAccount,
        OperationAddSelectOperation
    },
    props: {
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        operationToEdit: {
            type: Object,
            required: false
        },
        correctAndResendMode: {
          type: Boolean,
          required: false,
          default: false
        }
    },
    computed: {
        isFieldEditable() {
            return (fieldName) => {
                if (!this.correctAndResendMode) {
                    return true; // All fields editable in normal edit mode
                }

                // In correct and resend mode, only allow editing xt_* fields
                const editableFields = [
                    'xt_isin_code',
                    'xt_fund_name',
                    'xt_fund_official_reg_number',
                    'xt_fund_nif',
                    'xt_gestor',
                    'xt_gestor_official_reg_number',
                    'xt_gestor_nif',
                    'xt_provider',
                    'xt_provider_official_reg_number',
                    'xt_provider_nif',
                    'xt_account_origin',
                    'contribution_account_code'
                ];

                return editableFields.includes(fieldName);
            };
        },

        saveButtonText() {
            if (this.correctAndResendMode) {
                return 'Guardar y reenviar';
            }
            return this.edit ? 'Guardar cambios' : 'Crear operación';
        }
    },
    /**
     * @override
     */
    data() {
        return {
            loading: true,
            loadedEditData: false,
            newOperationState: {
                keyAddOperation: 0,
                isEdition: false,
                configs: [],
                account: {},
                account_patrimony: [],
                productType: {
                    type: null,
                    text: null
                },
                operationTypeList: [],
                productList: [],
                productSelected: null,
                operationTypeSelected: null,
                intervenerSelected: null,
                operationStep: 0,
                ordering: {},
                operationObj: {
                    shares: null,
                    netAmount: null,
                    grossAmount: null,
                    commission: null,
                    withholding: null,
                    per_period: null,
                    per_start_date: null,
                    per_end_date: null,
                    is_per_end_date_undefined: null,
                    per_increase_type: {
                        key: 'no-increase', name: 'Sin incremento'
                    },
                    per_increase: null,
                    per_increase_period: null,
                    product_target: null,
                    xt_isin_code: null,
                    xt_gestor: null,
                    xt_account_origin: null,
                    xt_fund_name: null,
                    xt_provider: null,
                    xt_fund_official_reg_number: null,
                    xt_fund_nif: null,
                    xt_gestor_official_reg_number: null,
                    xt_gestor_nif: null,
                    xt_provider_official_reg_number: null,
                    xt_provider_nif: null,
                    transfer_nav_on_month_end: null,
                    pp_redemption_cause: null,
                    pp_redemption_rendering_variation_type: null,
                    pp_redemption_rendering_variation: null,
                    pp_redemption_rendering_variation_date: null,
                    pp_redemption_collection_method: null,
                    pp_redemption_defer: null,
                    pp_source_situation: null,
                    pp_compartment: null,
                    pp_redemption_entitlement_date: null,
                    pp_plan_type: null,
                    pp_xt_dgs_code: null,
                    pp_xt_egs_code: null,
                    pp_rights_type: null,
                    pp_xt_collection_method: null,
                    pp_redemption_mixed_amount: null,
                    pay_method: null,
                    cnmvObject: null,
                    selectedMarketer: null,
                    nav_date: null,
                    contribution_account_code: null
                },
                notifyOperation: false,
                privateOperation: false,
                amountSharesIndicator: null,
                maxSharesToRefund: null,
                maxPositionsToRefund: null,
                source: null,
                sourceOptions: ['ONLINE', 'PRESENCIAL', 'CORREO'],
                min_contribution: null,
                max_contribution: null,
                productsLoaded: false,
                positionsLoaded: false,
                userCanManagePrivateOperations: false,
                isSuccesiveOperation: false,
                targetIsSuccesiveOperation: false,
                hasNewContributor: false,
                hasMailingTypeNewContributor: false,
                contributorType: null,
                newContributors: [],
                hasNewBeneficiaries: false,
                newBeneficiaries: [],
                isFromPeriodic: false,
                periodicInfoLoaded: false,
                employee: false
            },
            formWatcherProperties: ['form'],
            form: {},
            productMinimums: {
                minimum_investment: 0,
                minimum_to_maintain: 0,
                maximum_investment: Infinity
            },
        };
    },

    /**
     * @override
     */
    watch: {
        newOperationState: {
            handler() {
                if (!this.loading) {
                    this.form = this.newOperationState;
                }
            },
            deep: true
        }
    },

    methods: {
        /**
         * Load Product types
         */
        loadProductTypes() {
            const cfg = {
            };
            this.$productsService.getProducts('', cfg).then(res => {
                this.newOperationState.productsLoaded = true;
                this.newOperationState.productList = res.data.products;
                this.newOperationState.keyAddOperation++;
            });
        },
        /**
         * Load Operation types
         */
        loadOperationTypes() {

            /**
             * SUSCRIPCION - Suscripción -> FI
             * SUSCRIPCION_PERIODICA - Suscripción Periódica -> FI
             * SOLICITUD_SUSCRIPCION_PERIODICA - Solicitud Suscripción Periódica -> FI
             * SOLICITUD_TRASPASO_EXTERNO_ENTRADA - Traspaso Externo -> FI
             * SOLICITUD_TRASPASO_INTERNO - Traspaso Interno -> FI
             * REEMBOLSO - Reembolso -> FI
             * REEMBOLSO_PERIODICO - Reembolso Periódico -> FI
             * SOLICITUD_REEMBOLSO_PERIODICO - Solicitud Reembolso Periódico -> FI
             * APORTACION - Aportación -> PP
             * APORTACION_PERIODICA - Aportación Periódica -> PP
             * SOLICITUD APORTACION_PERIODICA - Solicitud Aportación Periódica -> PP
             * SOLICITUD_TRASPASO_EXTERNO_ENTRADA - Traspaso Externo -> PP
             * SOLICITUD_TRASPASO_INTERNO - Traspaso Interno -> PP
             * RESCATE - Rescate -> PP
             */

            this.$operationsService.getOperationTypes('', {}).then(res => {
                this.newOperationState.operationTypeList = res.data.operation_types.filter(operationType => {
                    const isTraspasoInternoPP = operationType.key_name === 'SOLICITUD_TRASPASO_INTERNO' && operationType.prt_key_name === 'P';
                    return !isTraspasoInternoPP;
                });
            });
        },
        /**
         * Load config vars
         */
        async loadConfigVars() {
            this.newOperationState.configs = this.$store.getters['configVarsStore/getConfigVars'];
            if (!this.newOperationState.configs.length) {
                const res = await this.$usersService.getConfigVars({});
                const configs = {};
                res.data.configurations.forEach(element => {
                    const key_name = element.key_name;
                    configs[key_name] = element.value;
                });
                this.newOperationState.configs = configs;
                this.$store.dispatch('configVarsStore/setConfigVars', configs);
            }
        },
        /**
         * @override
         */
        close_edit_operation() {
            this.$emit('close_edit_operation');
        },
        close_correct_and_resend_operation() {
            this.$emit('close_correct_and_resend_operation');
        },
        getUserCanManagePrivateOperations() {
            const { permission_set } = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
            const managePrivate = permission_set.permission_actions.find(pa => pa.key_name === 'MANAGE_PRIVATE_OPERATIONS');
            return managePrivate && managePrivate.value === true;
        },
        delete_operation_store() {
            this.deleteStoredComponentData();
        },
        async onProductChanged(product) {

            try {
                const response = await this.$accountsService.getAccountOperations(this.newOperationState.account.uuid, {
                    params: {
                        $filter: `{"operation_status":[{"in": "FINALIZED"}],"key_product":[{"in": "${product.key_name}"}]}`
                    }
                });
                const hasPreviousOps = response.data.related_operations.length > 0;
                this.newOperationState.isSuccesiveOperation = hasPreviousOps;
                await this.getMinimumsByProduct();
            } catch (error) {
                console.error('Error al verificar si es sucesiva la operación:', error);
                this.newOperationState.isSuccesiveOperation = false;
            }
        },
        async getMinimumsByProduct() {
            try {
                const params = {
                    key_name: this.newOperationState.productSelected.key_name,
                    investor_class: this.newOperationState.account.investor_class,
                    is_employed: this.newOperationState.employee,
                    is_first_investment: !this.newOperationState.isSuccesiveOperation
                };

                const response = await this.$productsService.getMinimums({ params });
                this.productMinimums = response.data.minimums;
            } catch (err) {
                console.error('Error al obtener mínimos:', err);
            }
        }
    },
    /**
     * @override
     */
    async beforeMount() {
        this.loadConfigVars();
        this.newOperationState.userCanManagePrivateOperations = this.getUserCanManagePrivateOperations();
        if (this.edit) {
            this.newOperationState.isEdition = true;
            this.newOperationState.uuid_operation = this.operationToEdit.operation_id;
            // Datos de la operación a editar
            this.newOperationState.operationObj = {
                shares: Number(this.operationToEdit.shares),
                netAmount: Number(this.operationToEdit.net_amount),
                grossAmount: Number(this.operationToEdit.gross_amount),
                commission: Number(this.operationToEdit.commission),
                withholding: Number(this.operationToEdit.withholding),
                per_start_date: this.operationToEdit.per_start_date ? this.$moment(this.operationToEdit.per_start_date).format('YYYY-MM-DD') : null,
                per_end_date: this.operationToEdit.per_end_date ? this.$moment(this.operationToEdit.per_end_date).format('YYYY-MM-DD') : null,
                is_per_end_date_undefined: this.operationToEdit.per_end_date ? false : true,
                per_increase: this.operationToEdit.per_increase ? `${this.operationToEdit.per_increase}` : undefined,
                xt_isin_code: this.operationToEdit.xt_isin_code,
                xt_fund_name: this.operationToEdit.xt_fund_name,
                xt_fund_official_reg_number: this.operationToEdit.xt_fund_official_reg_number,
                xt_fund_nif: this.operationToEdit.xt_fund_nif,
                xt_gestor: this.operationToEdit.xt_gestor,
                xt_gestor_official_reg_number: this.operationToEdit.xt_gestor_official_reg_number,
                xt_gestor_nif: this.operationToEdit.xt_gestor_nif,
                xt_provider: this.operationToEdit.xt_provider,
                xt_provider_official_reg_number: this.operationToEdit.xt_provider_official_reg_number,
                xt_provider_nif: this.operationToEdit.xt_provider_nif,
                xt_account_origin: this.operationToEdit.xt_acount_origin,
                is_total_redemption: this.operationToEdit.is_total_redemption,
                is_total_transfer: this.operationToEdit.is_total_transfer,
                product_target: null,
                transfer_nav_on_month_end: this.operationToEdit.transfer_nav_on_month_end,
                pp_redemption_rendering_variation: this.operationToEdit.pp_redemption_rendering_variation,
                pp_redemption_rendering_variation_date: this.operationToEdit.pp_redemption_rendering_variation_date ? this.$moment(this.operationToEdit.pp_redemption_rendering_variation_date).format('YYYY-MM-DD') : null,
                pp_redemption_entitlement_date: this.operationToEdit.pp_redemption_entitlement_date ? this.$moment(this.operationToEdit.pp_redemption_entitlement_date).format('YYYY-MM-DD') : null,
                pp_xt_dgs_code: this.operationToEdit.pp_xt_dgs_code,
                pp_xt_egs_code: this.operationToEdit.pp_xt_egs_code,
                pp_redemption_mixed_amount: this.operationToEdit.pp_redemption_mixed_amount,
                pay_method: null,
                per_increase_type: null,
                per_period: null,
                per_increase_period: null,
                amount_shares_indicator: null,
                pp_redemption_cause: null,
                pp_redemption_rendering_variation_type: null,
                pp_redemption_collection_method: null,
                pp_redemption_defer: null,
                pp_source_situation: null,
                pp_compartment: null,
                pp_plan_type: null,
                pp_rights_type: null,
                cnmvObject: {
                    isin: this.operationToEdit.xt_isin_code
                },
                selectedMarketer: {
                    nif: this.operationToEdit.xt_provider_nif
                },
                nav_date: this.operationToEdit.nav_date,
                contribution_account_code: this.operationToEdit.contribution_account_code
            };
            switch (this.operationToEdit.per_increase_type) {
                case 'LINEAL':
                    this.newOperationState.operationObj.per_increase_type = { key: 'LINEAL', name: 'Lineal' };
                    break;
                case 'PORCENTUAL':
                    this.newOperationState.operationObj.per_increase_type = { key: 'PORCENTUAL', name: 'Porcentual' };
                    break;
                case 'ACUMULATIVO':
                    this.newOperationState.operationObj.per_increase_type = { key: 'ACUMULATIVO', name: 'Acumulativo' };
                    break;
                default:
                    this.newOperationState.operationObj.per_increase_type = { key: 'no-increase', name: 'Sin incremento' };
                    break;
            }

            switch (this.operationToEdit.per_period) {
                case 'MENSUAL':
                    this.newOperationState.operationObj.per_period = { key: 'MENSUAL', name: 'Mensual' };
                    break;
                case 'TRIMESTRAL':
                    this.newOperationState.operationObj.per_period = { key: 'TRIMESTRAL', name: 'Trimestral' };
                    break;
                case 'SEMESTRAL':
                    this.newOperationState.operationObj.per_period = { key: 'SEMESTRAL', name: 'Semestral' };
                    break;
                case 'ANUAL':
                    this.newOperationState.operationObj.per_period = { key: 'ANUAL', name: 'Anual' };
                    break;
                default:
                    this.newOperationState.operationObj.per_period = null;
                    break;
            }

            switch (this.operationToEdit.per_increase_period) {
                case 'MENSUAL':
                    this.newOperationState.operationObj.per_increase_period = { key: 'MENSUAL', name: 'Mensual' };
                    break;
                case 'TRIMESTRAL':
                    this.newOperationState.operationObj.per_increase_period = { key: 'TRIMESTRAL', name: 'Trimestral' };
                    break;
                case 'ANUAL':
                    this.newOperationState.operationObj.per_increase_period = { key: 'ANUAL', name: 'Anual' };
                    break;
                case 'BIANUAL':
                    this.newOperationState.operationObj.per_increase_period = { key: 'BIANUAL', name: 'Binual' };
                    break;
                case 'TRIANUAL':
                    this.newOperationState.operationObj.per_increase_period = { key: 'TRIANUAL', name: 'Trianual' };
                    break;
                default:
                    this.newOperationState.operationObj.per_increase_period = null;
                    break;
            }

            const keyAmountSharesIndicator = this.operationToEdit.amount_shares_indicator;
            switch (keyAmountSharesIndicator) {
                case 'I':
                    this.newOperationState.amountSharesIndicator = {
                        key: 'I', name: 'Importe Neto'
                    };
                    break;
                case 'B':
                    this.newOperationState.amountSharesIndicator = {
                        key: 'B', name: 'Importe Bruto'
                    };
                    break;
                case 'P':
                    this.newOperationState.amountSharesIndicator = {
                        key: 'P', name: 'Participaciones'
                    };
                    break;
                case 'T':
                    this.newOperationState.amountSharesIndicator = {
                        key: 'T', name: 'Total'
                    };
                    break;
                default:
                    break;
            }

            switch (this.operationToEdit.pp_redemption_cause) {
                case 'JUBILACION':
                    this.newOperationState.operationObj.pp_redemption_cause = { key: 'JUBILACION', name: 'Jubilación' };
                    break;
                case 'INVALIDEZ':
                    this.newOperationState.operationObj.pp_redemption_cause = { key: 'INVALIDEZ', name: 'Invalidez' };
                    break;
                case 'DEPENDENCIA':
                    this.newOperationState.operationObj.pp_redemption_cause = { key: 'DEPENDENCIA', name: 'Dependencia' };
                    break;
                case 'ENFERMEDAD_GRAVE':
                    this.newOperationState.operationObj.pp_redemption_cause = { key: 'ENFERMEDAD_GRAVE', name: 'Enfermedad grave' };
                    break;
                case 'DESEMPLEO':
                    this.newOperationState.operationObj.pp_redemption_cause = { key: 'DESEMPLEO', name: 'Desempleo' };
                    break;
                case 'VARIACION_PRESTACION':
                    this.newOperationState.operationObj.pp_redemption_cause = { key: 'VARIACION_PRESTACION', name: 'Variación prestación' };
                    break;
                case 'FALLECIMIENTO':
                    this.newOperationState.operationObj.pp_redemption_cause = { key: 'FALLECIMIENTO', name: 'Fallecimiento' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_redemption_cause = null;
                    break;
            }

            switch (this.operationToEdit.pp_redemption_rendering_variation_type) {
                case 'INCREMENTO_RENTA':
                    this.newOperationState.operationObj.pp_redemption_rendering_variation_type = { key: 'INCREMENTO_RENTA', name: 'Incremento de la renta' };
                    break;
                case 'DISMINUCION_RENTA':
                    this.newOperationState.operationObj.pp_redemption_rendering_variation_type = { key: 'DISMINUCION_RENTA', name: 'Disminución de la renta' };
                    break;
                case 'ADELANTO_COBRO':
                    this.newOperationState.operationObj.pp_redemption_rendering_variation_type = { key: 'ADELANTO_COBRO', name: 'Adelanto del cobro de capital' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_redemption_rendering_variation_type = null;
                    break;
            }

            switch (this.operationToEdit.pp_redemption_collection_method) {

                case 'TOTAL':
                    this.newOperationState.operationObj.pp_redemption_collection_method = { key: 'TOTAL', name: 'Totalidad del capital' };
                    break;
                case 'MIXTA':
                    this.newOperationState.operationObj.pp_redemption_collection_method = { key: 'MIXTA', name: 'Renta Mixta' };
                    break;
                case 'FINANCIERA':
                    this.newOperationState.operationObj.pp_redemption_collection_method = { key: 'FINANCIERA', name: 'Renta financiera' };
                    break;
                case 'OTRAS':
                    this.newOperationState.operationObj.pp_redemption_collection_method = { key: 'OTRAS', name: 'Otras' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_redemption_collection_method = null;
                    break;
            }

            switch (this.operationToEdit.pp_redemption_defer) {
                case 'DIFERIDO':
                    this.newOperationState.operationObj.pp_redemption_defer = { key: 'DIFERIDO', name: 'Diferido' };
                    break;
                case 'NO_DIFERIDO':
                    this.newOperationState.operationObj.pp_redemption_defer = { key: 'NO_DIFERIDO', name: 'No diferido' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_redemption_defer = null;
                    break;
            }

            switch (this.operationToEdit.pp_source_situation) {
                case 'PARTICIPE':
                    this.newOperationState.operationObj.pp_source_situation = { key: 'PARTICIPE', name: 'Participe - derechos consolidados' };
                    break;
                case 'BENEFICIARIO':
                    this.newOperationState.operationObj.pp_source_situation = { key: 'BENEFICIARIO', name: 'Beneficiario - derechos económicos' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_source_situation = null;
                    break;
            }

            switch (this.operationToEdit.pp_compartment) {
                case '1':
                    this.newOperationState.operationObj.pp_compartment = { key: '1', name: 'Anteriores a 2007' };
                    break;
                case '2':
                    this.newOperationState.operationObj.pp_compartment = { key: '2', name: 'Posteriores a 2007' };
                    break;
                case '3':
                    this.newOperationState.operationObj.pp_compartment = { key: '3', name: 'De ambos' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_compartment = null;
                    break;
            }

            switch (this.operationToEdit.pp_plan_type) {
                case 'PPA':
                    this.newOperationState.operationObj.pp_plan_type = { key: 'PPA', name: 'PPA' };
                    break;
                case 'PP':
                    this.newOperationState.operationObj.pp_plan_type = { key: 'PP', name: 'PP' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_plan_type = null;
                    break;
            }

            switch (this.operationToEdit.pp_rights_type) {
                case 'C':
                    this.newOperationState.operationObj.pp_rights_type = { key: 'C', name: 'Derechos consolidados' };
                    break;
                case 'E':
                    this.newOperationState.operationObj.pp_rights_type = { key: 'E', name: 'Derechos económicos' };
                    break;
                case 'A':
                    this.newOperationState.operationObj.pp_rights_type = { key: 'A', name: 'Ambos' };
                    break;
                default:
                    this.newOperationState.operationObj.pp_rights_type = null;
                    break;
            }

            switch (this.operationToEdit.pay_method) {
                case 'DOMICILIACION':
                    this.newOperationState.operationObj.pay_method = { key: 'DOM', name: 'DOMICILIACION' };
                    break;
                case 'TRANSFERENCIA':
                    this.newOperationState.operationObj.pay_method = { key: 'TRF', name: 'TRANSFERENCIA' };
                    break;
                case 'CHEQUE':
                    this.newOperationState.operationObj.pay_method = { key: 'CHQ', name: 'CHEQUE' };
                    break;
                case 'OMF':
                    this.newOperationState.operationObj.pay_method = { key: 'OMF', name: 'OFICINA' };
                    break;
                default:
                    this.newOperationState.operationObj.pay_method = null;
                    break;
            }


            this.newOperationState.source = this.operationToEdit.source;
            if (this.operationToEdit.payer) {
                this.operationToEdit.ordering = this.operationToEdit.payer.uuid;

                this.$intervenersService.getIntervenersByUUIId(this.operationToEdit.ordering, {})
                    .then(res => {
                        this.newOperationState.ordering = res.data.intervener.personal_data;
                        this.newOperationState.ordering.uuid = this.operationToEdit.ordering;
                    });
            }
            Promise.all([
                this.$accountsService.getAccountsByUUId(this.operationToEdit.account_id, {}),
                this.$accountsService.getAccountInterveners(this.operationToEdit.account_id, {}),
                this.$productsService.getProducts('', {}),
                this.$operationsService.getOperationTypes('', {}),
                this.$accountsService.getAccountBankAccounts(this.operationToEdit.account_id, {})
            ]).then(res => {
                this.newOperationState.productsLoaded = true;
                this.newOperationState.positionsLoaded = true;

                this.newOperationState.account = res[0].data.account;
                this.newOperationState.account_patrimony = res[0].data.account.account_patrimony || [];
                this.newOperationState.account.uuid_distributor = res[0].data.account.uuid_distributor;
                this.newOperationState.account.uuid_subdistributor = res[0].data.account.uuid_subdistributor;

                this.newOperationState.account.interveners = res[1].data.accounts_intervener;
                this.newOperationState.account.interveners.forEach(intervener => {
                    if (intervener.uuid === this.operationToEdit.ordering) {
                        this.newOperationState.ordering = intervener;
                    }
                });
                this.newOperationState.employee = res[1].data.accounts_intervener.find(
                    i => i.uuid === this.operationToEdit.ordering
                ).is_employed || false;
                this.newOperationState.productList = res[2].data.products;
                this.newOperationState.productList.forEach(product => {
                    if (product.key_name === this.operationToEdit.key_product) {
                        this.newOperationState.productSelected = product;
                        // TODO: Mock... como no tenemos valores de los productos, le pongo a pincho que vale 100...
                        if (!this.newOperationState.productSelected.net_asset_value) {
                            this.newOperationState.productSelected.net_asset_value = 100;
                            this.newOperationState.productSelected.net_asset_value_date = new Date();
                        }
                        if (product.prt_key_name === 'F') {
                            this.newOperationState.productType = { type: 'F', text: 'Fondo de inversión' };
                        } else {
                            this.newOperationState.productType = { type: 'P', text: 'Plan de pensiones' };
                        }
                    }
                    if (product.key_name === this.operationToEdit.key_target_product) {
                        this.newOperationState.operationObj.product_target = product;
                    }
                });
                this.newOperationState.operationTypeList = res[3].data.operation_types;

                if (this.operationToEdit.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA') {
                    if (['INNOCAPITAL_GLOBAL', 'INNOCAPITAL_MIXTO_GLOBAL'].includes(this.operationToEdit.key_product)) {
                        this.newOperationState.operationTypeSelected = this.newOperationState.operationTypeList.find(operation => {
                            return operation.key_name === this.operationToEdit.key_operation_type && operation.prt_key_name === 'P';
                        });
                    } else {
                        this.newOperationState.operationTypeSelected = this.newOperationState.operationTypeList.find(operation => {
                            return operation.key_name === this.operationToEdit.key_operation_type && operation.prt_key_name === 'F';
                        });
                    }
                } else {
                    this.newOperationState.operationTypeList.forEach(operation => {
                        if (operation.key_name === this.operationToEdit.key_operation_type) {
                            this.newOperationState.operationTypeSelected = operation;
                        }
                    });
                }

                const fake = { account_number: 'Nueva cuenta', is_fake: true };
                this.newOperationState.account.bankAccounts = res[4].data.bank_accounts;
                this.newOperationState.account.bankAccounts.push(fake);

                this.operationToEdit.uuid_bank_account = this.operationToEdit.uuid_bank_account;
                this.newOperationState.account.bankAccounts.forEach(bankAccount => {
                    if (bankAccount.uuid === this.operationToEdit.uuid_bank_account) {
                        this.newOperationState.bankAccount = bankAccount;
                    }
                });

                this.newOperationState.account.products = [];
                this.newOperationState.account.patrimony = 0;
                this.$accountsService.getAccountPositions(this.operationToEdit.account_id, {})
                    .then(res2 => {
                        res2.data.account_positions.forEach(element => {
                            const key_product = element.key_product;
                            this.newOperationState.account.products[key_product] = {};
                            this.newOperationState.account.products[key_product].shares = element.shares;
                            this.newOperationState.account.products[key_product].net_asset_value = element.net_asset_value;
                            this.newOperationState.account.products[key_product].net_asset_value_date = element.net_asset_value_date;
                            this.newOperationState.account.products[key_product].positions = element.current_value;
                            this.newOperationState.account.patrimony += Number(element.current_value);
                        });
                        this.newOperationState.keyAddOperation++;
                    })
                    .finally(() => {
                        this.loadedEditData = true;
                    });
            });

            this.newOperationState.operationStep = 4;

        } else {
            if (this.$route.query.type === 'periodic') {
                this.newOperationState.isFromPeriodic = true;
            }
            await Promise.all([this.loadProductTypes(), this.loadOperationTypes()]);
        }
    },
    mounted() {
        if (!this.edit) {
            const storedFormProperties = this.getStoredComponentData();
            if (storedFormProperties && storedFormProperties.form && Object.entries(storedFormProperties.form).length) {
                this.newOperationState = { ...this.newOperationState, ...storedFormProperties.form };
            }
        }
        this.loading = false;
    }
};
